<template>
  <div>
    <a-modal :visible="modalVisible" :closable="false" :width="1170" @cancel="closeModal">
      <a-table :width="1200" :columns="columns" :data-source="taskList">
        <span slot="issueTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{
            taskStatus[record.status].label }}</a-tag>
        </span>
        <span slot="serious" slot-scope="text, record">
          {{ 'P'+record.serious }}
        </span>
        <span slot="isOverTime" slot-scope="text, record">
          <a-tag v-if="record.isOverTime == 1" color="red">{{ '是' }}</a-tag>
          <a-tag v-if="record.isOverTime == 0" color="green">{{ '否' }}</a-tag>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>

<script>
import { taskStatus } from '@/utils/dictionary';
export default {
  props: {
    taskList: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      modalVisible: false,
      taskStatus,
      columns: [
        {
          title: '缺陷id',
          dataIndex: 'issueId',
          width: '7%',
          key: 'issueId',
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '缺陷标题',
          dataIndex: 'title',
          width: '25%',
          key: 'title',
          scopedSlots: { customRender: 'issueTitle' }
        },
        {
          title: '等级',
          dataIndex: 'serious',
          width: '7%',
          key: 'serious',
          scopedSlots: { customRender: 'serious' }
        },
        {
          title: '创建时间',
          dataIndex: 'createdTime',
          width: '15%',
          key: 'createdTime',
          scopedSlots: { customRender: 'createdTime' }
        },
        {
          title: '解决时间',
          dataIndex: 'responseTime',
          width: '15%',
          key: 'responseTime',
          scopedSlots: { customRender: 'responseTime' }
        },
        {
          title: '超时',
          dataIndex: 'isOverTime',
          width: '7%',
          key: 'isOverTime',
          scopedSlots: { customRender: 'isOverTime' }
        },
        {
          title: '处理人',
          dataIndex: 'handler',
          width: '10%',
          key: 'handler',
          scopedSlots: { customRender: 'handler' }
        },
        {
          title: '重新打开次数',
          dataIndex: 'reopen_times',
          width: '10%',
          key: 'reopen_times',
          scopedSlots: { customRender: 'reopen_times' }
        }
      ]
    };
  },
  computed: {
    link() {
      return record => {
        return record && record.projectId && record.issueId ? this.$router.resolve({ name: 'page:project:quality:issue:detail', query: { issueId: record.issueId }, params: { project_id: record.projectId }}).href : '';
      };
    }
  },
  methods: {
    // 获取任务列表
    getTodoList() {
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    open() {
      this.modalVisible = true;
    }
  }
};
</script>

<style scoped>
    .purple {
      background-color: rgba(128, 50, 150, 0.5);
      color: white;
      border-radius: 6px;
    }

    .orange {
      background-color: orange;
      color: white;
      border-radius: 6px;
    }

    .purple-orange {
      background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
      color: white;
      border-radius: 6px;
    }
</style>

